import { Link } from "react-router-dom";
import { Phone, CalendarCheck, MessageSquare } from "lucide-react";

const cell = "flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 min-h-[60px] text-white font-display uppercase font-700 text-sm tracking-wide";

export default function MobileActionBar() {
  return (
    <div
      data-testid="mobile-action-bar"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 grid grid-cols-3 border-t border-[#2A2B31] bg-[#0A0A0B]/95 backdrop-blur-md"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a href="tel:0485741524" data-testid="mobilebar-bel" aria-label="Bel TT Motorsports: 0485 74 15 24" className={`${cell} border-r border-[#2A2B31] active:bg-[#141518]`}>
        <Phone size={19} className="text-[#E10600]" /> Bellen
      </a>
      <button type="button" data-testid="mobilebar-chat" onClick={() => window.dispatchEvent(new Event("tt-open-chat"))}
        aria-label="Open de chat" className={`${cell} border-r border-[#2A2B31] active:bg-[#141518]`}>
        <MessageSquare size={19} className="text-[#E10600]" /> Chat
      </button>
      <Link to="/afspraak" data-testid="mobilebar-afspraak" className={`${cell} bg-[#E10600] active:bg-[#B80500]`}>
        <CalendarCheck size={19} /> Afspraak
      </Link>
    </div>
  );
}
